import { render, staticRenderFns } from "./Kontaktieren.vue?vue&type=template&id=fc5ff700&scoped=true&"
import script from "./Kontaktieren.vue?vue&type=script&lang=js&"
export * from "./Kontaktieren.vue?vue&type=script&lang=js&"
import style0 from "./Kontaktieren.vue?vue&type=style&index=0&id=fc5ff700&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5ff700",
  null
  
)

export default component.exports